<template>
  <CardTemplate>
    <template #icon>
      <v-img
        class="account-img"
        src="./assets/update-info.svg"
        alt=""
        role="presentation"
        width="46px"
        height="46px"
      />
    </template>
    <template #title>
      {{ $t('L_mobile_phone_number') }}
    </template>
    <template v-if="mobileNoExists" #content>
      <p
        :class="
          !$vuetify.display.xs
            ? 'd-flex align-center ga-2 justify-center mt-4'
            : 'd-block text-left mt-0 ml-2 pb-4 pl-16'
        "
      >
        <span v-if="!customerProfile" class="d-block">&nbsp; &ndash; </span>
        <span v-if="customerProfile" class="d-block">
          {{ formatedContactNumber }}
          <span v-if="!$vuetify.display.xs">&nbsp; &ndash; </span>
        </span>
        <span class="d-block">{{ bindVerifiedLabel }}</span>
      </p>
      <div
        class="cursor-pointer verifynow d-flex align-center justify-center pa-3"
        v-if="mobileNoExists && !mobileNoVerified"
        @click.stop="$emit('verify-now')"
      >
        <OnexButton
          size="sm"
          variant="text"
          id="verify_now"
          :aria-label="$t('L_verify_now')"
          @click.stop="$emit('verify-now')"
        >
          {{ $t('L_verify_now') }}
        </OnexButton>
      </div>
    </template>
    <template v-else #content>
      <p
        class="content"
        :class="
          !$vuetify.display.xs
            ? 'd-flex align-center justify-center mt-4'
            : 'd-block text-left mt-0 ml-2 pb-4 pl-14'
        "
      >
        {{ $t('L_to_keep_you_account') }}
      </p>
    </template>
  </CardTemplate>
</template>
<script lang="ts">
import { useGlobalStore } from '@/stores/global/global.store';
import { defineComponent, type ComponentOptions } from 'vue';
import { mapState, mapStores } from 'pinia';
import { OnexButton } from '@primerica/onex-ui-lib';
import CardTemplate from './CardTemplate.vue';
const componentOptions: ComponentOptions = {
  name: 'UpdateContactMobile',
  components: {
    CardTemplate,
    OnexButton,
  },
  props: {
    formatedContactNumber: {
      type: String,
      required: true,
    },
    mobileNoExists: {
      type: Boolean,
      required: true,
      default: false,
    },
    mobileNoVerified: {
      type: Boolean,
      required: true,
      default: false,
    },
    bindVerifiedLabel: {
      type: String,
      required: true,
    },
    customerProfile: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  computed: {
    ...mapStores(useGlobalStore),
    ...mapState(useGlobalStore, {
      featureActive: 'containsFeature',
    }),
  },
};

export default defineComponent(componentOptions);
</script>
<style lang="scss" scoped>
.verifynow {
  background-color: #eee;
}
</style>
